import React, { useState, useEffect, useRef, Fragment, useCallback } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { DataGridPro, GridRowModes, GridActionsCellItem, GridRowEditStopReasons, GridColumnMenu, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, useGridApiRef, GRID_CHECKBOX_SELECTION_COL_DEF, GridFooter } from '@mui/x-data-grid-pro';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import { FaChevronDown } from 'react-icons/fa';
import BusinessIcon from '@mui/icons-material/Business';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';

import { formatPhone } from '../../common/utils';
import { ToastContainer } from 'react-toastify';
import AddToGroup from '../../components/Modals/AddToGroup';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import { ModalCtx } from '../../contexts';
import { launchPhoneBurner } from '../../common/utils';
import { singleSelectQuickFilter } from '../../common/utils';
import { update } from '../../common/api';
import Toolbar from './toolbar';
import { useGridConfig } from '../../components/Grids/useGridConfig';


import "react-toastify/dist/ReactToastify.css";


function useQuery() {
    return new URLSearchParams( useLocation().search );
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const BizPartners = ( { org, orgId, aid, uid, user, grids, viewing, canExport, stack, contacts, lists, setDatagridWidth, setDatagridOrder } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    const [ partners, setPartners ] = useState( [] );
    const [ loading, setLoading ] = useState( true );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    // const [ cols, setCols ] = useState( [] );
    // const [ gridReady, setGridReady ] = useState( false );
    // const [ filterModel, setFilterModel ] = useState( { items: [] } );
    const [ q, setQ ] = useState( '' );
    // const [ classLogic, setClassLogic ] = useState( '' );
    const [ rowModesModel, setRowModesModel ] = useState( {} );
    // const [ filterModel, setFilterModel ] = useState( [] );
    // const [ filterName, setFilterName ] = useState( '' );

    const containerRef = useRef();
    const titleRef = useRef();
    
    const gridRef = useGridApiRef();

    const location = useLocation();

    const query = useQuery();

    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
          event.defaultMuiPrevented = true;
        }
    };
    
    const handleEditClick = useCallback( ( id ) => () => {
        console.log( 'edit click: ', id );
        setRowModesModel( { 
            ...rowModesModel, 
            [id]: { mode: GridRowModes.Edit } 
        } );
    }, [ rowModesModel ] );
    
    const handleSaveClick = useCallback( (id) => () => {
        setRowModesModel( { 
            ...rowModesModel, 
            [id]: { mode: GridRowModes.View } 
        } );
    }, [ rowModesModel ] );
    
    const handleCancelClick = useCallback( (id) => () => {
        setRowModesModel( {
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        } );
    }, [ rowModesModel ] );
    
    const processRowUpdate = ( newRow ) => {
        const updatedRow = { ...newRow, isNew: false };
        console.log( 'processRowUpdate: ', newRow );
        // setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };
    
    const handleRowModesModelChange = ( newRowModesModel ) => {
        setRowModesModel( newRowModesModel );
    };

    const handleColumnWidthChange = async ( { colDef, width } ) => {
        const datagrid = 'bizpartners';

        let newWidths = {};
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newWidths[col.field] = col.width;
            }
        } );
        setDatagridWidth( { grid: datagrid, values: newWidths, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-width', uid, {
            grid: datagrid,
            values: newWidths,
            fn: filterName
        } );
    }

    const handleColumnOrderChange = async ( params ) => {
        const datagrid = 'bizpartners';

        const newOrder = [];
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newOrder.push( col.field );
            }
        } );
        setDatagridOrder( { grid: datagrid, values: newOrder, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-order', uid, {
            grid: datagrid,
            values: newOrder,
            fn: filterName
        } );
    }

    const handleFilterChange = useCallback( ( newFilterModel ) => {
        // setFilterModel( newFilterModel )
        console.log( 'newFilterModel:', newFilterModel );
        // const datagrid = 'bizpartners';

        // const newOrder = [];
        // gridRef.current.getAllColumns().forEach( col => {
        //     if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
        //         newOrder.push( col.field );
        //     }
        // } );
        // setDatagridOrder( { grid: datagrid, values: newOrder, fn: filterName } );
        // await update( orgId, aid, uid, 'datagrid-order', uid, {
        //     grid: datagrid,
        //     values: newOrder,
        //     fn: filterName
        // } );
    }, [] );

    const formatName = ( cid ) => {
        const r = contacts[cid];
        let name;

        if ( r ) {
            name = '-- Not Entered --';

            if ( r.firstname ) {
                name = r.firstname;
            }
            if ( r.lastname ) {
                name += ( r.firstname ) ? ' ' : '';
                name += r.lastname;
            }
        }

        return name;
    };

    const gridHelpers = {
        valueGetter: {
            contact: ( { row } ) => {
                return formatName( row.cid );
            },
            referral: ( { row } ) => {
                return formatName( row.referredById );
            },
            phone: ( { row } ) => {
                let p;  
                const c = contacts[row.cid];
                if ( c && c.phoneMobile && c.phoneMobile.length ) {
                    p = c.phoneMobile;
                } else if ( c && c.phone && c.phone.length ) {
                    p = c.phone;
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            email: ( { row } ) => {
                let e;
                const c = contacts[row.cid];
                if ( c && c.email && c.email.length ) {
                    e = c.email;
                }
                return ( e ) ? e : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value.match( 'T' ) ? value : value + 'T12:00:00' );
                    // d.setDate( d.getDate() + 1 );
                }
                return ( d ) ? d : null;
            },
            groups: ( { row } ) => {
                const ships = [];
                Object.keys( lists ).forEach( gid => {
                    const l = lists[gid];
                    if ( l && l.cids && l.cids.includes( row.cid ) ) {
                        ships.push( l );
                    }
                } );
                return ( ships.length ) ? ships.map( m => m.label ).join( ', ' ) : null; 
            }
        },
        renderCell: {
            phone: ( { value } ) => {
                return ( value ) ? <a href={`tel:${value}`}>{value}</a> : null;
            },
            email: ( { value } ) => {
                return ( value ) ? <a href={`mailto:${value}`}>{value}</a> : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            contact: ( { row } ) => {
                let l;
                if ( row && row.cid ) {
                    const c = contacts[row.cid];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            referral: ( { row } ) => {
                let l;
                if ( row && row.referredById ) {
                    const c = contacts[row.referredById];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            // groups: ( { value } ) => {
            //     // return ( value && value.length ) ? value.map( m => <Link to={`/list/${m.gid}`}>{m.label}</Link> ).join( ', ' ) : null;
            //     return ( value && value.length ) ? value.map( m => m.label ).join( ', ' ) : null; 
            // }
        },
        valueFormatter: {
            phone: ( { value } ) => {
                return ( value ) ? value : null;
            },
            email: ( { value } ) => {
                return ( value ) ? value : null;
            },
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            contact: ( { value } ) => {
                return ( value ) ? value : '';
            },
            referral: ( { value } ) => {
                return ( value ) ? value : '';
            },
            // groups: ( { value } ) => {
            //     return ( value && value.length ) ? value.map( m => m.label ).join( ', ' ) : null; 
            // }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };

    const { cols, filterModel, ready, handlers, classLogic, filterName, usingFilter } = useGridConfig( 'bizpartners', {
        user, grids, gridHelpers, query, handleFilterChange
    } );
    
    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleModal = async ( t ) => {
        let shouldOpen = true;

        const list = [];
        const allCids = [];
        const emailCids = [];
        const phoneCids = [];
        const uniqueEmails = new Set();
        const uniquePhones = new Set();
        selectedRows.forEach( cid => {
            const c = contacts[cid];
            if ( c ) {
                list.push( c );
                allCids.push( cid );
                if ( c.email && c.email.length ) {
                    if ( !uniqueEmails.has( c.email.toLowerCase() ) && c.optoutEmail !== true ) {
                        uniqueEmails.add( c.email.toLowerCase() );
                        emailCids.push( cid );
                    }
                }
                let p = c.phoneMobile || c.phone || c.phoneWork || c.phoneHome;
                if ( p && p.length ) {
                    p = formatPhone( p );
                    if ( !uniquePhones.has( p ) && c.optoutSms !== true ) {
                        uniquePhones.add( p );
                        phoneCids.push( cid );
                    }
                }
            }
        } );
                
        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} clist={emailCids} objType='contact' aid={viewing[0]} /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} clist={phoneCids} objType='contact' /> );
                break;

            case 'list':
                setModal( <AddToGroup close={closeModal} itemType='contacts' items={allCids} aid={viewing[0]} /> );
                break;
    
            case 'event':
                setModal( <AddEvent close={closeModal} contacts={list} /> );
                break;

            case 'phoneburner':
                await launchPhoneBurner( aid, uid, selectedRows, list, stack.dialer );
                shouldOpen = false;
                break;

            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const getRowClassName = ( params ) => {
        let cn = '';
        // console.log( classLogic );
        if ( classLogic ) {
            eval( classLogic );
        }
        return cn;
    }

    useEffect( () => {
        document.title = 'Third Floor - Business Partners';
    }, [] );

    // useEffect( () => {
    //     let filters = {};
    //     for ( let [ key, value ] of query.entries() ) {
    //         filters[key] = value;
    //     }

    //     if ( grids && grids.bizpartners && !gridReady ) {
    //         let activeFilter = false;
    //         setFilterName( '' );

    //         let storedCols = JSON.parse( grids.bizpartners.cols );
    //         if ( filters.fn && grids.bizpartners.filters && grids.bizpartners.filters[filters.fn] ) {
    //             if ( grids.bizpartners.filters[filters.fn].cols ) {
    //                 activeFilter = true;
    //                 setUsingFilter( true );
    //                 setFilterName( filters.fn );
    //                 storedCols = JSON.parse( grids.bizpartners.filters[filters.fn].cols );
    //             }

    //             if ( grids.bizpartners.filters[filters.fn].criteria ) {
    //                 const crit = JSON.parse( grids.bizpartners.filters[filters.fn].criteria );
    //                 setFilterModel( { items: crit } );
    //             }

    //             if ( grids.bizpartners.filters[filters.fn].className ) {
    //                 setClassLogic( grids.bizpartners.filters[filters.fn].className );
    //             }
    //         } else {
    //             if ( filters.crit ) {
    //                 const crit = JSON.parse( filters.crit );
    //                 setFilterModel( { items: crit } );
    //             }
    //             if ( grids.bizpartners.className ) {
    //                 setClassLogic( grids.bizpartners.className );
    //             }
    //         }

    //         if ( storedCols ) {
    //             let cols = storedCols.map( c => {
    //                 if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
    //                     c.renderCell = gridHelpers.renderCell[c.renderCell];
    //                 }
    //                 if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
    //                     c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
    //                 }
    //                 if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
    //                     c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
    //                 }
    //                 if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
    //                     c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
    //                 }
                    
    //                 if ( user && user.datagrids && user.datagrids.bizpartners ) {
    //                     if ( activeFilter ) {
    //                         if ( user.datagrids.bizpartners.filters && user.datagrids.bizpartners.filters[filters.fn] && user.datagrids.bizpartners.filters[filters.fn].colSize && user.datagrids.bizpartners.filters[filters.fn].colSize[c.field] ) {
    //                             c.width = user.datagrids.bizpartners.filters[filters.fn].colSize[c.field];
    //                         }
    //                     } else if ( user.datagrids.bizpartners.colSize && user.datagrids.bizpartners.colSize[c.field] ) {
    //                         c.width = user.datagrids.bizpartners.colSize[c.field];
    //                     }
    //                 }
    //                 // c.editable = true;
    //                 return c;
    //             } );

    //             if ( user && user.datagrids && user.datagrids.bizpartners ) {
    //                 if ( activeFilter ) {
    //                     if ( user.datagrids.bizpartners.filters && user.datagrids.bizpartners.filters[filters.fn] && user.datagrids.bizpartners.filters[filters.fn].colOrder && user.datagrids.bizpartners.filters[filters.fn].colOrder.length ) {
    //                         cols = user.datagrids.bizpartners.filters[filters.fn].colOrder.map( field => {
    //                             return storedCols.find( f => f.field === field );
    //                         } );
    //                     }
    //                 } else {
    //                     if ( user.datagrids.bizpartners.colOrder && user.datagrids.bizpartners.colOrder.length ) {
    //                         cols = user.datagrids.bizpartners.colOrder.map( field => {
    //                             return storedCols.find( f => f.field === field );
    //                         } );
    //                     }
    //                 }
    //             }

    //             setCols( cols );
    //             setGridReady( true );
    //         }
    //     }
    // }, [ user, grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady, query, handleCancelClick, handleEditClick, handleSaveClick, rowModesModel ] );


    // useEffect(() => {
    //     if ( location.search !== q ) {
    //         setGridReady( false );
    //         // setFilterModel( { items: [] } );
    //         setClassLogic( '' );
    //         setQ( location.search );
    //     }
    // }, [ location.search, q ] ); 
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        let list = [];

        if ( contacts ) {
            const sharePartners = ( org && org.sharePartners === true ) ? true : false;

            Object.keys( contacts ).forEach( cid => {
                const c = contacts[cid];
                if ( c.priRole !== 'partner' ) {
                    return;
                }

                if ( sharePartners || viewing.includes( c.aid ) ) {
                    list.push( c );
                }
            } );
        }
        setPartners( list );
        setLoading( false );
    }, [ contacts, viewing, org ] );

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );
    
    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <BusinessIcon />
                                        <span className='ps-2 fw-bold fs-6'>Business Partners</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ModalCtx.Provider value={ { openModal, closeModal, setModal } }>
                                        {
                                            ( ready ) ? (
                                                <DataGridPro
                                                    apiRef={ gridRef }
                                                    initialState={ { 
                                                        pinnedColumns: { 
                                                            left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ],
                                                            right: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'actions' ],
                                                        },
                                                    } }
                                                    loading={ loading }
                                                    rows={ partners }
                                                    columns={ cols }
                                                    density='compact'
                                                    checkboxSelection
                                                    disableRowSelectionOnClick
                                                    slots={ { 
                                                        toolbar: Toolbar,
                                                        columnMenu: customColumnMenu 
                                                    } }
                                                    slotProps={ { toolbar: {
                                                        selectedRows: selectedRows, 
                                                        handleModal: handleModal, 
                                                        hasTxting: hasTxting, 
                                                        hasPhoneBurner: hasPhoneBurner, 
                                                        canExport: canExport,
                                                        viewing: viewing
                                                    } } }
                                                    onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                                    onColumnWidthChange={ handleColumnWidthChange }
                                                    onColumnOrderChange={ handleColumnOrderChange }
                                                    getRowId={ ( row ) => row.cid }
                                                    filterModel={ filterModel }
                                                    onFilterModelChange={ handlers.onFilterModelChange }
                                                    getRowClassName={ getRowClassName }
                                                    editMode='row'
                                                    // rowModesModel={ rowModesModel }
                                                    // onRowModesModelChange={ handleRowModesModelChange }
                                                    // onRowEditStop={ handleRowEditStop }
                                                    // processRowUpdate={ processRowUpdate }
                                                />
                                            ) : (
                                                null
                                            )
                                        }
                                    </ModalCtx.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    org: state.user.org,
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    contacts: state.contacts.byId,
    lists: state.lists.byId
} );

const mapDispatch = ( dispatch ) => ( {
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder
} );

export default connect( mapProps, mapDispatch )( BizPartners );